import { useContext, useEffect, useReducer, useState } from "react";
import { Contexto } from "../Context/Contexto";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { tokens } from "../Context/Tokens";
import { RespuestaInicial, RespuestaLoginDTO } from "../Model/RespuestaLoginDTO";
import { Get, GetSinRetorno, Post2 } from "../Rutas/ApiRest";
import { Redireccion, cuentaCliente } from "../Rutas/Servicios";
import { Loading, MensajeGoogle, Modelos } from "./Modelos";
import logo from "./logo-eshopex.png" 
import Chat from "../Componentes/chat";
import { desactivar } from "../Model/DesactivarPagina";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { MensajeCont } from "../Context/MensajeContext";
import ReactGA from 'react-ga4';
import { CookiesProvider, useCookies } from 'react-cookie'


import { decryptAES, encryptAES } from "../Componentes/encriptacion";

function Login() {

  const [state,dispatch]=useReducer(reducer,{User:"",Contrasena:""})
  const [Respuesta,SetRespuesta]=useState<RespuestaLoginDTO>(RespuestaInicial)
  const {ActualizarCli,Cli}=useContext(Contexto)
  const {SetDatosGoogle}=useContext(MensajeCont)
  const {toggleTodo}=useContext(tokens)
  const {tok}=useContext(tokens)
  const {SetLoading,SetMensajeEmergente,Loadings}=useContext(MensajeContActualizacion)
  const [ActivoGoogle,SetActivoGoogle]=useState<number>(0)
  const [cookies, setCookie,removeCookie] = useCookies(['rutcli','mensaje'])
  const desactiva=desactivar
  
  function reducer(state:any,action:any)
  {
    switch(action.type)
    {
      case "cambio":return {
        ...state,[action.input.name]:action.input.value
      }
      case "Reinicio":return{User:"",Contrasena:""}
    }
   
    return state;
  }

  function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }

    const key=(e:any)=>
    {
      if (e.key === 'Enter')
      {
        carga();
      }
    }
    

    const carga=()=>
    {
      SetLoading(true);
      activador()
    }

    useEffect(()=>{

      ReactGA.send({
        hitType:"pageview",
        page:"/",
        title:"Login"
      })
      if(cookies.mensaje=="Mandado")
      {
        setCookie('mensaje', "") 
        toggleTodo();
        LogeoGoogle();
        if(Cli!=null)
        {
          if((Cli.rut==0 ) && tok.access_token!="d" && tok.access_token==undefined)
          {
            
              if(decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY) !=undefined)
              {
                
                if(decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY) !=null)
                {
                  
                  if(decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY)>0)
                  {
                   
                    const dato=Get(cuentaCliente.DatosClientes.replace("@rut",decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY)),"application/json",tok)
                    dato.then(resultado=>{ActualizarCli(resultado);})
                  }else
                  {
                    SetLoading(false)
                    
                  }
                  
                }else
                {
                  SetLoading(false)
                  
                }
                
              }else
              {
                SetLoading(false)
                
              }
              
          }
          else
          {
    
            SetLoading(false)
            
          }
        }else
        {
          SetLoading(false)
        }
        
      }else
      {
        if(localStorage.getItem('email')==null)
          {
            
            toggleTodo();
            LogeoGoogle();
          }else
          {
            if(localStorage.getItem("source")==null)
            {
              toggleTodo();
              LogeoGoogle();
            }else
            {
              window.location.href=Redireccion.datosExtraGoogle
            }
          }
        
      }
      

    },[])



    const Activador2=(correo:string)=>
    {
      const verificar=Get(cuentaCliente.InicioGoogle.replace("@email",correo),"application/json","")
      verificar.then(resultado=>{

        setCookie('rutcli',encryptAES(Respuesta.RutCli,process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})
        SetRespuesta(resultado)

      }
      )
    }

    const deco=(token:string)=>
    {
     
      SetLoading(true)
       const parts=token.split(".");
       if(parts.length==3)
       {
        
        const email=JSON.parse(atob(parts[1]))
        localStorage.setItem('nombre',email.given_name)
        localStorage.setItem('apellido',email.family_name)
        localStorage.setItem('email',email.email)
        if(email.email_verified)
        {
          Activador2(email.email)
        }else
        {
          SetLoading(false)
        }
       }else
       {
        SetLoading(false)
       }
    }

    const respuestaGoogle=(respuestas:any)=>
    {
      const dato=GetSinRetorno(cuentaCliente.AumentoGoogle,"application/json",tok)
      deco(respuestas.credential)
      
    }


    useEffect(()=>
    {
      SetLoading(true);
      if(Cli!=null)
      {
        if((Cli.rut==0 ) && tok.access_token!="d" && tok.access_token==undefined)
        {
            if(cookies.rutcli !=undefined)
            {
              
              if(decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY) !=null)
              {
                if(decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY)>0)
                {
                 
                  const dato=Get(cuentaCliente.DatosClientes.replace("@rut",decryptAES(cookies.rutcli,process.env.REACT_APP_API_KEY)),"application/json",tok)
                  dato.then(resultado=>{ActualizarCli(resultado);})
                }else
                {
                  SetLoading(false)
                  
                }
                
              }else
              {
                SetLoading(false)
                
              }
              
            }else
            {
              SetLoading(false)
              
            }
            
        }
        else
        {
  
          SetLoading(false)
          
        }
      }else
      {
        SetLoading(false)
      }
      
    },[tok])

    const LogeoGoogle=()=>
    {
      
      const dato=Get(cuentaCliente.VerificacionGoogle,"application/json",tok)
            dato.then((resultado:any)=>{
              SetActivoGoogle(resultado)

            })
    }

    const activador=()=>
    {
      
      if(!desactiva.Activo)
      {
                var body={
                  "email": state.User,
                  "contrasena":state.Contrasena
                }
          const verificar=Post2(cuentaCliente.VerificarContrasena,JSON.stringify(body),"application/json","")
          verificar.then(resultado=>{
            
            SetRespuesta(resultado)
          }
        )
      }else
      {
        SetMensajeEmergente(desactiva.mensaje)
        SetLoading(false)
      }

    }

    useEffect(()=>
    {
      if(Respuesta!=RespuestaInicial)
      {
        if(Respuesta.valido==0)
        {
          
          if (Respuesta.Mensaje.includes("registrado en nuestros datos"))
          {
            
            window.location.href=Redireccion.datosExtraGoogle
          }else
          {
            localStorage.clear();
            removeCookie("rutcli")
            removeCookie("mensaje")
            SetMensajeEmergente(Respuesta.Mensaje)
          }
          
          SetLoading(false)
        }else
        {
          if(Respuesta.RutCli>0)
          {
            removeCookie("rutcli")
            removeCookie("mensaje")
            localStorage.clear();
            setCookie('rutcli',encryptAES(Respuesta.RutCli+"",process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})
             const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Respuesta.RutCli+""),"application/json",tok)
             datos.then(resultado=>{ActualizarCli(resultado);})
          }
        }
      }
    },[Respuesta])
    
    return (
      <>
      <CookiesProvider>

      
      {!Loadings?<><div className="container">
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex justify-content-center py-4"> <a className="logo d-flex align-items-center w-auto img-fluid" href="https://eshopex.cl"> <img src={logo} alt=""></img></a> </div>
            

            <div className="card mb-3">
              <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Mi eShopex</h5>
                </div>
                <div className="row g-3 needs-validation" >
                  <div className="col-12">Email/Ecode
                    <div className="input-group has-validation">
                    <input name="User" type="text"  id="User" value={state.User} onChange={cambio} className="form-control" placeholder="E-mail" onKeyDown={key}></input>
                      <div className="invalid-feedback">Ingresa tu Email o Ecode</div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Clave</label>
                    <input name="Contrasena"  value={state.Contrasena} onChange={cambio} type="password" id="ContentPlaceHolder1_txtClave" className="form-control" onKeyDown={key}></input>
                    <div className="invalid-feedback">Ingresa tu clave</div>
                  </div>
                  <div className="col-12">
                    <p className="small" ><a href="/RecuperarContrasena/" style={{textDecoration:"none",color:"#f98824"}}>Olvidé mi contraseña</a></p>
                  </div>
                  <div className="col-12" style={{marginTop:"-5px"}}>
                    <button className="btn btn-primary w-100" type="submit" onClick={()=>{carga()}} style={{color:"#fff",backgroundColor:"#f98824",borderColor:"#f98824"}}>Iniciar Sesión</button>
                  </div>

                 

                  <div className="col-12">
                    <p className="small">¿No tienes cuenta? <a href="https://eshopex.cl/registro/?VarUrl=STD_CL" style={{textDecoration:"none",color:"#f98824"}}>Regístrate</a></p>
                  </div>
                  
                  {ActivoGoogle==1?<><hr style={{marginTop:"-5px"}}></hr>
                  <div className="col-12" style={{marginTop:"-5px",alignItems:"center",justifyContent:"center",display:"flex" }}>
                  <label className="form-label" >Inicie o Cree su cuenta con Google</label>
                  </div>
                  <div className="col-12" style={{alignItems:"center",justifyContent:"center",display:"flex" }}> <GoogleOAuthProvider
                  clientId="671055403996-n0p3q6ia2u5dq98glnodrtib1sp1qkud.apps.googleusercontent.com">

                  <GoogleLogin onSuccess={respuestaGoogle}></GoogleLogin>
                </GoogleOAuthProvider></div></>:null}

                  <div className="col-12">
                    <p className="small"><a href="https://eshopex.cl" style={{textDecoration:"none",color:"#f98824"}}>Volver Pagina Principal </a></p>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
      
  </>
  
  :null}
      
  <Chat></Chat>
  <Modelos></Modelos>
     <Loading></Loading>
     <MensajeGoogle></MensajeGoogle>
     </CookiesProvider>
      </>
    );
  }
  
  export default Login;